import React from 'react';
import { HelpCircle } from 'lucide-react';

/**
 * InfoTooltip - Displays a question mark icon with an explanatory tooltip
 * Used to explain metrics and how they are calculated
 */
const InfoTooltip = ({ content, className = '' }) => {
  return (
    <div className={`relative group inline-flex items-center ${className}`}>
      <HelpCircle className="w-4 h-4 text-slate-400 hover:text-slate-600 cursor-help transition-colors" />
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-slate-900 text-white text-xs rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 shadow-lg w-64 text-left">
        <div className="whitespace-normal leading-relaxed">
          {content}
        </div>
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1 border-4 border-transparent border-t-slate-900"></div>
      </div>
    </div>
  );
};

export default InfoTooltip;
